import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import useUserStore from 'graph/state/query-hooks/use-user';

const ReadingLevel: React.FC = () => {
  const classes = useStyles();
  const [user] = useUserStore();
  const readingLevel = user?.me?.groups?.[0]?.name;
  if (!readingLevel) return null;
  return (
    <Box className={classes.content}>
      <Typography className={classes.text}>{readingLevel}</Typography>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  content: {
    width: '100%',
    display: 'flex',
  },
  text: {
    fontSize: theme.typography.pxToRem(30),
    fontFamily: FONT_GSS_FUTURA_BOLD,
  },
}));

export default ReadingLevel;
